const router = [
  {
    path: '/domestic_consultation_form_list',
    name: 'DomesticConsultationFormList',
    component: () => import('@/views/PurchaseManagement/DomesticConsultationForm/List.vue'),
    meta: {
      title: '国内咨询单 列表'
    }
  },
  {
    path: '/push_9011',
    name: 'DomesticConsultationFormPush9011',
    component: () => import('@/views/PurchaseManagement/DomesticConsultationForm/Push.vue'),
    meta: {
      title: '国内咨询单 提醒'
    }
  }
];

export default router;
